import axios, { AxiosResponse } from 'axios';
import { matchesUrl } from 'findem-helpers';

export interface IGetIcpCampaignStatsPayload {
  summary: boolean;
  icp_ids: string[];
  joid: string;
  include_direct_outreach: boolean;
}

const EmailTemplatesAPI = {
  fetchTemplates: async (payload: { joid: string }): Promise<AxiosResponse<any>> => {
    return axios.get(`${matchesUrl}/api/email-templates`, { params: payload });
  },

  getIcpCampaignStats: async (payload: IGetIcpCampaignStatsPayload): Promise<AxiosResponse<any>> => {
    return axios.post(`${matchesUrl}/hm/api/email_templates`, {
      ...payload,
      type: 'IcpCampaignStats'
    }, { withCredentials: true });
  },
};

export default EmailTemplatesAPI;
